import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import EtcForm from '../../../components/employeemng/personal/EtcForm';
import { listEtc } from '../../../modules/empModule/empPersonal';





const EtcFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('기타사항명을 입력하세요'),
    attrVal2: yup.string().nullable(''),
    attrVal3: yup.string().nullable(''),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'ETC',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listEtc({
              id: employee.usrUuid,
              infoTyp: 'ETC',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <EtcForm formik={formik} />;
};

export default EtcFormContainer;
